import React from 'react';
import {
  View, Text, StyleSheet, Pressable,
} from 'react-native';
import Colors from '../../../../../constants/Colors';
import DeleteIcon12 from '../../../../../components/12pxIcons/DeleteIcon12';
import Style from '../../../../../constants/Style';

interface TicketFilterTagProps {
  title: string,
  value: string,
  onPress: () => void,
  testID?: string,
}

const TicketFilterTag = ({
  title, value, onPress, testID,
}: TicketFilterTagProps) => <View
  style={styles.container}
  {...{ testID }}
>
    <Text style={styles.text}>{title}</Text>
    <Text style={[styles.text, styles.value]}>{value}</Text>
    <Pressable
      style={(state: { hovered: boolean, pressed: boolean }) => [
        state.hovered && Style.hovered, state.pressed && Style.pressed,
      ]}
      {...{ onPress }}
    >
      <DeleteIcon12 style={styles.deleteIcon} />
    </Pressable>
  </View>;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: Colors.light.hereworksWhite100,
    alignSelf: 'flex-start',
    paddingVertical: 4,
    paddingHorizontal: 12,
    marginRight: 4,
    marginBottom: 4,
    alignItems: 'center',
  },
  text: {
    color: Colors.light.hereworksBlack400,
    fontFamily: 'Roboto_400Regular',
    fontSize: 12,
    lineHeight: 14,
  },
  value: {
    color: Colors.light.hereworksBlack600,
  },
  deleteIcon: {
    marginStart: 12,
  },
});

export default TicketFilterTag;
